import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
let Details = class Details extends Vue {
    sourceImage;
    detailsData;
    backImageUrl = require('@blade-sxp/search-center/assets/images/back.png');
    nextImageUrl = require('@blade-sxp/search-center/assets/images/right.png');
    toggleLoading = false;
    next() {
        if (this.toggleLoading)
            return;
        this.$emit('next');
    }
    prev() {
        if (this.toggleLoading)
            return;
        this.$emit('prev');
    }
    getLoading(val) {
        this.toggleLoading = val;
    }
};
__decorate([
    Prop()
], Details.prototype, "sourceImage", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsData", void 0);
Details = __decorate([
    Component({
        name: 'Toolbar',
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
